import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Select from "react-select";

var CmfForm = function CmfForm(props) {
  var poliza = props.poliza,
      _onChange = props.onChange,
      token = props.token;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      generalConditions = _React$useState2[0],
      setGeneralConditions = _React$useState2[1];

  var getGeneralConditions = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, response, reponseJson;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = "/api/v1/general_conditions";
              _context.prev = 1;
              _context.next = 4;
              return fetch(url, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-Token": token
                }
              });

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response.json();

            case 7:
              reponseJson = _context.sent;
              setGeneralConditions(reponseJson);
              return _context.abrupt("return", reponseJson);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    return function getGeneralConditions() {
      return _ref.apply(this, arguments);
    };
  }();

  var setCmfOption = function setCmfOption(general_condition) {
    return {
      label: "".concat(general_condition.code, " - ").concat(general_condition.name),
      value: general_condition.code
    };
  };

  var cmfOptions = generalConditions && generalConditions.map(function (condition) {
    return setCmfOption(condition);
  });
  var currentValue = (poliza === null || poliza === void 0 ? void 0 : poliza.general_condition_code) && generalConditions && generalConditions.find(function (condition) {
    return condition.code === poliza.general_condition_code;
  });
  var currentValueFormat = currentValue && setCmfOption(currentValue);
  React.useEffect(function () {
    if (!generalConditions) getGeneralConditions();
  }, [generalConditions]);
  return /*#__PURE__*/React.createElement(Select, {
    options: cmfOptions,
    value: currentValueFormat,
    isSearchable: true,
    onChange: function onChange(item) {
      return _onChange && _onChange(item.value);
    }
  });
};

export default CmfForm;